import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Forms from "../../../../Components/Form";
import toast from "react-hot-toast";
import Header from "../../../../Components/Header";
import {
  create_home_testimonial,
  get_home_testimonial,
  update_home_testimonial,
} from "../../../../Controllers/Home/Testimonials";
import forms from "../../../../Data/Forms/Home/Testimonials/forms";
import headers from "../../../../Data/Forms/Home/Testimonials/headers";
import Loadercomponent from "../../../../Components/Loader";
import AddButton from "../../../../Components/Buttons/add";
import RemoveButton from "../../../../Components/Buttons/delete";
import { convert_to_file } from "../../../../Controllers/Global";

const HomeTestimonialsForm = () => {
  let { id } = useParams();
  let navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [values, setValues] = useState(forms);

  const formdata = async (data) => {
    if (data?.status) {
      setButtonLoader(true);

      const testimonial = id
        ? await update_home_testimonial({ ...data?.data, id: id })
        : await create_home_testimonial(data?.data);

      if (testimonial?.status) {
        if (id) {
          navigate(-1);
        }
        toast?.success(testimonial?.message);
        setButtonLoader(false);
      } else {
        toast?.error(testimonial?.message);
        setButtonLoader(false);
      }
    }
  };

  const handleData = async (testimonial) => {
    let image = testimonial?.image ? testimonial?.image : "";
    let file = await convert_to_file(image);
    let name = testimonial?.name ? testimonial?.name : "";
    let description = testimonial?.description ? testimonial?.description : "";
    let address = testimonial?.address ? testimonial?.address : "";
    let status = testimonial?.status ? testimonial?.status : 0;

    forms[0].options[0].form.value = [file];
    forms[0].options[1].form.value = name;
    forms[0].options[2].form.value = description;
    forms[0].options[3].form.value = address;
    forms[0].options[4].form.value = status;

    setLoader(false);
    setValues([...values]);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);

      const data = {
        id: id,
      };

      const testimonial = await get_home_testimonial(data);
      if (testimonial?.status) {
        handleData(testimonial?.data);
      } else {
        toast?.error(testimonial?.message);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header header={headers}>
      <Loadercomponent loader={loader}>
        <Forms
          form={values}
          setForm={setValues}
          formdata={formdata}
          buttonLoader={buttonLoader}
        />
      </Loadercomponent>
    </Header>
  );
};

export default HomeTestimonialsForm;
